export default {
    productionAPI: "https://inspections.qbitlabs.io/api",
    devAPI:        "http://localhost:3000/api",
    pathAPI:       "https://inspections.qbitlabs.io/api",
}
